export { DashboardHeader, type DashboardHeaderProps } from './DashboardHeader';
export { default } from './DashboardHeader';

